import { Card } from "./Card";

import "./CardMedia.scss";

export namespace CardMedia {
	export type Data = {
		title?: string;
		date?: Date;
		content?: string;
		badge?: string | { type: "date"; };
		media: {
			type: "image" | "icon";
			src: string;
			alt?: string;
		};
		link?: string;
	};
	export type Options = {
		template: "card" | "info";
		background?: "primary" | "secondary";
		layout?: "vertical" | "horizontal";
		span?: "max";
	};
	export type Props = {
		options: Options;
		data: Data;
	};
}
export class CardMedia extends Card<CardMedia.Props> {

	override get cls() {
		return {
			...super.cls,
			CardMedia: true,
			[`template-${this.props.options.template}`]: true,
			[`background-${this.props.options.background ?? "primary"}`]: true,
			[`layout-${this.props.options.layout ?? "vertical"}`]: true,
			[`span-${this.props.options.span ?? "normal"}`]: !!this.props.options.span
		};
	}

	protected renderBadge() {
		const { data } = this.props;
		if (!data.badge) return null;
		if (typeof data.badge === "string") {
			return <div class="badge">{data.badge}</div>;
		} else if (data.badge.type === "date" && data.date) {
			const dateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
			return (
				<div class="badge">
					{data.date.toLocaleDateString(undefined, dateOptions)}
				</div>
			);
		}
		return null;
	}

	protected renderMedia() {
		const { data } = this.props;
		return (
			<div class="media">
				{data.media.type === "image" ? (
					<img src={data.media.src} alt={data.media.alt ?? "Card Image"} />
				) : (
					<img class="icon" src={data.media.src} alt={data.media.alt ?? "Card Icon"} />
				)}
				{this.renderBadge()}
			</div>
		);
	}

	public renderReadMoreIcon() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="read-more-icon">
				<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
			</svg>
		);
	}

	public override render() {
		const dateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
		const { data } = this.props;
		return (
			<div class={this.cls} style={this.props.style}>
				{this.renderMedia()}
				<div class="container">
					{data.date &&
						(typeof (data.badge) !== "object" || data.badge.type !== "date") && (
							<div class="date">{data.date.toLocaleDateString(undefined, dateOptions)}</div>
						)}
					{data.title &&
						<h2 class="title">{data.title}</h2>
					}
					{data.content &&
						<p class="content">
							{data.content}
						</p>
					}
					{/* <div class="read-more"><a href={data.link}>Read More</a></div> */}
					{data.link && (
						<a href={data.link}>
							<div class="read-more">
								<span>Read More</span>
								{this.renderReadMoreIcon()}
							</div>
						</a>
					)}
				</div>
			</div>
		);
	}
}
